import { render } from "./SavedListGrid.vue?vue&type=template&id=e490e64e"
import script from "./SavedListGrid.vue?vue&type=script&lang=js"
export * from "./SavedListGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__